import { FC } from "react";
import { useNavigate } from "react-router";

import { useCounter } from "../hooks";
import { Button } from "../../ui/layout/molecules/Button";
import { LoaderIcon } from "../../ui/icons";
import { CENTERED_COLUMN_CLASSNAME } from "../general";

export const Verified: FC<React.PropsWithChildren> = () => {
  const navigate = useNavigate();

  const { isCounting, counter } = useCounter(5);

  return (
    <div className={`${CENTERED_COLUMN_CLASSNAME} justify-center`}>
      {isCounting && <LoaderIcon className="mb-4 animate-spin " />}

      <Button
        buttonType="primary"
        title={`Redirect me to the dashboard ${isCounting ? counter : ""}`}
        className="w-full"
        onClick={() => {
          navigate("/");
        }}
        capitalize={false}
        disabled={isCounting}
      />
    </div>
  );
};
